import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "../TandemTypes";

export type ARMInitializationPayload = {
  version: number;
};

export type ARMInitializationEvent = ARMInitializationPayload;

const armInitializationSchema = z.object({
  version: z.number(),
});

export const LID_ARM_INIT = {
  value: 0x63,
  name: "ARM Initialization Event",
  format: "i............",
  fields: ["version"],
  postprocess: rec => rec,
  schema: armInitializationSchema,
} as const satisfies TandemEventDefinition<ARMInitializationPayload, ARMInitializationEvent>;
